import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import * as z from "zod";

export const markToteAsFull = {
  name: "markToteAsFull" as const,
  input: z.object({ pickSessionId: z.string(), toteId: z.string() }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
    message: z.string().optional(),
  }),
};
